export default __webpack_public_path__ + "9cebd7db4d0a0966fb941d5c80898086.svg";